export const catchExternalLinks = (callback: any) => {
  function _gaLt(event: any) {
    let el = event.srcElement || event.target

    // loop up the DOM tree through parent elements if clicked element is not a link (eg: an image inside a link)
    while (
      el &&
      (typeof el.tagName === 'undefined' || el.tagName.toLowerCase() !== 'a' || !el.href)
    ) {
      el = el.parentNode
    }

    // if a link with valid href has been clicked
    if (el && el.href) {
      const link = el.href

      // only if it is an external link
      if (link.indexOf(window.location.host) === -1 && !link.match(/^javascript:/i)) {
        // is target set and _(self|parent|top)
        let target = el.target && !el.target.match(/^_(self|parent|top)$/i) ? el.target : false

        // assume a target if Ctrl|shift|meta-click
        if (event.ctrlKey || event.shiftKey || event.metaKey || event.which === 2) {
          target = '_blank'
        }

        let hbrun = false // tracker has not yet run

        // hitBack to open link in same window after tracker
        const hitBack = function () {
          // run once only
          if (hbrun) {
            return
          }
          hbrun = true
          window.location.href = link
        }

        if (target) {
          // if target opens a new window then just track
          callback(link)
        } else {
          // prevent standard click, track then open
          if (event?.preventDefault) {
            event.preventDefault()
          }
          callback(link)

          // run hitBack again if GA takes longer than 1 second
          setTimeout(hitBack, 1000)
        }
      }
    }
  }

  const _gaLtEvt = 'ontouchstart' in window ? 'click' : 'mousedown'

  window.addEventListener(_gaLtEvt, _gaLt, false)
}
